export function installFilePicker(Room) {
    const proto = Room.prototype;
    const open = proto.openDriveBrowser;
    proto.openDriveBrowser = async function (...args) {
        this.filePickerSource = this.getInspectionDriveViewScope() === 'shared' ? 'shared' : 'personal';
        this.filePickerCartExpanded = false;
        this.filePickerDragging = false;
        this._filePickerLocations = {};
        await open.apply(this, args);
    };
    proto.selectFilePickerSource = async function (source) {
        if (!['personal', 'shared', 'reports'].includes(source) || source === this.filePickerSource) return;
        const old = this.filePickerSource;
        if (old !== 'reports') {
            this._filePickerLocations ||= {};
            this._filePickerLocations[old] = { folder: this.driveBrowserCurrentFolder, search: this.driveSearchText };
        }
        this.filePickerSource = source;
        if (source === 'reports') {
            await this.loadDriveReportFolder(this.driveReportCurrentFolder || '');
        } else {
            const saved = this._filePickerLocations?.[source];
            this.driveBrowserScope = source;
            this.driveBrowserView = null;
            this.driveSearchText = saved?.search || '';
            await this.loadDriveBrowserFolder(saved?.folder || '');
        }
        await this.service.render();
    };
    for (const [name, get] of Object.entries({
        pickerFiles() { return this.filePickerSource === 'reports' ? this.filteredDriveReportFiles : this.filteredDriveBrowserFiles; },
        pickerFolders() { return this.filePickerSource === 'reports' ? this.filteredDriveReportFolders : this.filteredDriveBrowserFolders; },
        pickerBreadcrumb() { return this.filePickerSource === 'reports' ? this.driveReportBreadcrumb : this.driveBrowserBreadcrumb; },
        pickerLoading() { return this.filePickerSource === 'reports' ? this.driveReportLoading : this.driveBrowserLoading; },
        pickerError() { return this.filePickerSource === 'reports' ? this.driveReportError : this.driveBrowserError; },
        pickerHasParent() { return this.filePickerSource === 'reports' ? !!this.driveReportCurrentFolder : this.canDriveBrowseUp(); },
        pickerSelectableFiles() { return (this.pickerFiles || []).filter(file => this.canAddDriveFile(file)); },
        pickerAllSelected() { return this.pickerSelectableFiles.length > 0 && this.pickerSelectableFiles.every(file => this.isDriveFileSelected(file)); },
        pickerSomeSelected() { return !this.pickerAllSelected && this.pickerSelectableFiles.some(file => this.isDriveFileSelected(file)); },
        pickerSupportingCount() { return this.pickerSelectableFiles.filter(file => this.getCoreSupportingDriveFileType(file)).length; }
    })) Object.defineProperty(proto, name, { configurable: true, get });
    Object.defineProperty(proto, 'pickerSearch', {
        configurable: true,
        get() { return this.filePickerSource === 'reports' ? this.driveReportSearchText : this.driveSearchText; },
        set(value) { if (this.filePickerSource === 'reports') this.driveReportSearchText = value; else this.driveSearchText = value; }
    });
    proto.pickerNavigate = async function (folder = '') {
        if (this.filePickerSource === 'reports') await this.driveReportNavigate(folder);
        else { this.driveSearchText = ''; await this.driveBrowseNavigate(folder); }
    };
    proto.pickerUp = async function () {
        if (this.filePickerSource === 'reports') await this.driveReportUp();
        else await this.driveBrowseUp();
    };
    proto.refreshPicker = async function () {
        if (this.filePickerSource === 'reports') await this.loadDriveReportFolder(this.driveReportCurrentFolder || '');
        else await this.loadDriveBrowserFolder(this.driveBrowserCurrentFolder || '');
    };
    proto.togglePickerFiles = async function (event) {
        for (const file of this.pickerSelectableFiles) this.setDriveCartFile(file, !!event.target.checked);
        await this.service.render();
    };
    proto.selectPickerSupportingFiles = async function () {
        for (const file of this.pickerSelectableFiles) if (this.getCoreSupportingDriveFileType(file)) this.setDriveCartFile(file, true);
        await this.service.render();
    };
    proto.togglePickerCart = async function () {
        this.filePickerCartExpanded = !this.filePickerCartExpanded;
        await this.service.render();
    };
    proto.pickerFileExtension = function (file) {
        const name = String(file?.name || '');
        const extension = name.includes('.') ? name.split('.').pop().toUpperCase() : 'FILE';
        return extension.length <= 5 ? extension : 'FILE';
    };
    proto.onPickerDragOver = function (event) {
        event.preventDefault(); event.stopPropagation();
        if (!this.sending) this.filePickerDragging = true;
    };
    proto.onPickerDragLeave = function (event) {
        if (!event.currentTarget.contains(event.relatedTarget)) this.filePickerDragging = false;
    };
    proto.onPickerDrop = async function (event) {
        event.preventDefault(); event.stopPropagation(); this.filePickerDragging = false;
        if (this.sending) return;
        const files = Array.from(event.dataTransfer?.files || []);
        if (files.length) await this.uploadSessionFiles(files, this.driveBrowserFileType || 'additional');
        await this.service.render();
    };
}
